import { Model } from "./model";
import { Choice } from "./choice.model";

export class Question extends Model {
    id: number;
    quiz_id: number;
    label: string;
    choices: Array<Choice>;
}


// WEBPACK FOOTER //
// ./src/models/question.model.ts